<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Visualização de Usuário" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-admin :readonly="true" :editing="false" :user="model" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { onMounted, ref, Ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import FormAdmin from './form-admin.vue'
import type Admin from '@/types/Admin'
import AdminService from '@/services/AdminService'
import { useLoader } from '@/stores/loader'
import { useRoute } from 'vue-router'
import { useSnackBar } from '@/stores/snackbar'

const loader = useLoader()
const route = useRoute()
const snackbar = useSnackBar()

const model: Ref<Admin> = ref({} as Admin)

async function fetch() {
  try {
    loader.increment()
    const response = await (new AdminService()).show(route.params.id as string)
    model.value = response.data.data
  } catch (error) {
    snackbar.show(
      'Não foi possível buscar o usuário',
      'error',
    )

    throw error
  } finally {
    loader.decrement()
  }
}

onMounted(() => fetch())
</script>
